/**
 * 缓存说明:电费账单缓存
 */
import vm from '@/cache/storeTools.js'

import meterReadingApi from '@/components/api/meterReading/meterReadingApi.js'

var basestate = {
	// 当前公司信息
	nowUnit: {},
	columns: [
				{
					name: '业主姓名',
					key: 'userName',
					type: 'slot'
				},{
					name: '水表',
					key: 'deviceName'
				},{
					name: '用水量(m³)',
					key: 'electricQuantity'
				},{
					name: '抄表日期',
					key: 'createTime',
					type: 'slot'
				},{
					name: '结算类型',
					key: 'accountType',
					type: 'slot'
				},{
					name: '实际用水时间',
					key: 'Time',
				},{
					name: '基本水费(元)',
					key: 'basicFee',
					type: 'slot'
				},{
					name: '水费(元)',
					key: 'electricFee',
					type: 'slot'
				},{
					name: '合计(元)',
					key: 'amount',
					type: 'slot'
				},
				//2020-08-23 lxk 账户余额
				{
					name: '账户余额(元)',
					key: 'userBalance',
					type: 'slot'
				},

				{
					name: '缴费状态',
					key: 'state',
					type: 'slot'
				},{
					name: '操作',
					key: 'operate',
					type: 'slot'
				}
			],
	chargingStatusList: [{text:'全部'},{text:'未缴费',value:0},{text:'已缴费',value:1}],
	accountTypeList: [{text:'全部'},{text:'月结',value:0},{text:'预付费',value:1},{text:'预付费-月账单',value:2}],
	meterList: [], // 抄表设备列表
	unitDeductionFeeDay: null, // 单位抄表日期
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		setNowUnit(state, unit) {
			if(unit == undefined || isempty(unit)){
				return
			}
			vm.Vue.set(state, 'nowUnit', unit)
			store.commit('getMeterReadingConfigList', unit.id)
			//store.commit('getUnitDeductionFeeDay')
		},

		getMeterReadingConfigList(state, unitId){
			meterReadingApi.getMeterReadingConfigListByUnitId(unitId, respon => {
				vm.Vue.set(state, 'meterList', respon)
			})
		},
	}
});

//对外提供
export default store